<template>
  <b-modal
    id="column-filter-date-modal"
    v-model="active"
    :size="modalSize"
    centered
    hide-footer
    hide-header
    @close="close"
  >
    <svg-icon name="times-bold" :size="8" class="modal-dialog__close" @click="close"></svg-icon>

    <div class="m-column-filters">
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="conditions"
          />
        </div>
        <div v-if="condition.value !== 'range'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model="value"
            class="m-column-filters__value m-column-filters__value_string"
            size="small"
            icon="calendar"
            :icon-right="true"
            type="date"
            :editable="true"
            :required="dateError"
          />
        </div>
        <div class="period">
          <div class="period-wrapper">
            <div v-if="condition.value === 'range'" class="m-column-filters__item m-column-filters__item_value">
              <c-input
                v-model="rangeValue.start"
                class="m-column-filters__value m-column-filters__value_string"
                size="small"
                icon="calendar"
                :icon-right="true"
                type="date"
                :editable="true"
                :required="startError || rangeError"
              />
            </div>
            <div v-if="condition.value === 'range'" class="m-column-filters__item-sep">-</div>
            <div v-if="condition.value === 'range'" class="m-column-filters__item m-column-filters__item_value">
              <c-input
                v-model="rangeValue.end"
                class="m-column-filters__value m-column-filters__value_string"
                size="small"
                icon="calendar"
                :icon-right="true"
                type="date"
                :editable="true"
                :required="endError || rangeError"
              />
            </div>
          </div>

          <error-feedback
            v-if="startError || endError || rangeError"
            :text="startError || endError || rangeError"
          ></error-feedback>
        </div>
        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="apply"
          />
          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="reset"
          />
          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="reset" />
          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="apply" />
        </div>
      </div>
      <!-- <div class="m-column-filters__error">{{ error }}</div> -->
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import SvgIcon from "@/components/svg-icon";
import ErrorFeedback from "@/components/error-feedback";

const conditions = [
  { label: "Дата", value: "date" },
  { label: "До", value: "before" },
  { label: "После", value: "after" },
  { label: "Период", value: "range" },
];

export default {
  name: "date-filter",
  components: {
    "c-button": Button,
    "c-input": Input,
    SvgIcon,
    ErrorFeedback,
  },

  data() {
    return {
      active: false,
      submitted: false,

      conditions,
      condition: conditions[0],
      value: "",
      rangeValue: {
        start: "",
        end: "",
      },
    };
  },

  computed: {
    startError() {
      if (!this.submitted) return false;
      if (this.condition.value !== "range") return false;
      if (!this.rangeValue.start) return "Обязательное поле";
      if (this.rangeValue.start.length < 10) return "Некорректный формат";
      const start = moment(this.rangeValue.start, "DD.MM.YYYY");

      if (!start.isValid) return "Некорректный формат";
      return false;
    },
    endError() {
      if (!this.submitted) return false;
      if (this.condition.value !== "range") return false;
      if (!this.rangeValue.end) return "Обязательное поле";
      if (this.rangeValue.end.length < 10) return "Некорректный формат";

      const end = moment(this.rangeValue.end, "DD.MM.YYYY");
      if (!end.isValid) return "Некорректный формат";
      return false;
    },
    dateError() {
      if (!this.submitted) return false;
      if (this.condition.value === "range") return false;
      if (!this.value) return "Обязательное поле";
      if (this.value.length < 10) return "Некорректный формат";
      const date = moment(this.value, "DD.MM.YYYY");
      if (!date.isValid) return "Некорректный формат";
      return false;
    },
    rangeError() {
      if (!this.submitted) return false;
      if (this.condition.value !== "range") return false;
      if (this.startError || this.endError) return false;
      const start = moment(this.rangeValue.start, "DD.MM.YYYY");
      const end = moment(this.rangeValue.end, "DD.MM.YYYY");

      if (start.isAfter(end)) return "Некорректный интервал";

      return false;
    },
    error() {
      if (!this.submitted) return false;

      return this.startError || this.endError || this.rangeError || this.dateError;
    },
    modalSize() {
      if (this.condition.value === "range") {
        return "date-range";
      }
      return "date";
    },
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (this.active && event.keyCode === 13) {
        this.apply();
      }
    });
  },

  methods: {
    getParams() {
      if (this.condition.value === "range") {
        const range = this.rangeValue;
        if (range.start && range.end) {
          return {
            from: range.start,
            to: range.end,
            searchType: this.condition.value,
          };
        }
        return null;
      }

      if (!this.value) return null;

      return {
        value: this.value,
        searchType: this.condition.value,
      };
    },

    open(params) {
      this.resetValue();

      if (params) {
        const { searchType } = params;
        const condition = this.conditions.find((c) => c.value === searchType);
        this.condition = condition || conditions[0];

        if (this.condition.value === "range") {
          this.rangeValue = {
            start: params.from,
            end: params.to,
          };
        } else {
          this.value = params.value;
        }
      }

      this.active = true;
    },

    close() {
      this.active = false;
      this.submitted = false;
      this.$emit("close");
    },

    resetValue() {
      this.value = "";
      const [firstCondition] = conditions;
      this.condition = firstCondition;
      this.rangeValue.start = "";
      this.rangeValue.end = "";
    },

    reset() {
      this.$emit("apply", null);
      this.close();
    },

    apply() {
      this.submitted = true;
      if (this.error) return;
      this.$emit("apply", this.getParams());
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.period {
  &-wrapper {
    display: flex;

    & /deep/ {
      .c-input-required {
        display: none;
      }
    }
  }
}
</style>
